import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, MessageCircle, MapPin, Phone, Mail } from 'lucide-react';
import Logo from './Logo';
import { CATEGORIES, BIGTIME_WHATSAPP } from '@/mock/products';
import { useCategories } from '@/store/dataStore';

export default function Footer() {
  const { categories } = useCategories();
  const CATS = categories && categories.length ? categories : CATEGORIES;
  return (
    <footer className="bg-[#1B2A4A] text-white/90 mt-12">
      <div className="max-w-7xl mx-auto px-4 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <Logo className="h-10 mb-3" />
          <p className="text-sm text-white/70 mb-4">Todo en un solo lugar. Tu tienda de confianza en Venezuela.</p>
          <div className="flex gap-3">
            <a href={`https://wa.me/${BIGTIME_WHATSAPP}`} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-yellow-300 hover:text-[#1B2A4A] flex items-center justify-center transition"><MessageCircle size={18} /></a>
            <a href="https://instagram.com/bigtime_ca" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full bg-white/10 hover:bg-yellow-300 hover:text-[#1B2A4A] flex items-center justify-center transition"><Instagram size={18} /></a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-yellow-300 hover:text-[#1B2A4A] flex items-center justify-center transition"><Facebook size={18} /></a>
          </div>
        </div>

        <div>
          <h4 className="text-yellow-300 font-bold mb-3 text-sm uppercase tracking-wider">Categorías</h4>
          <ul className="space-y-2 text-sm">
            {CATS.slice(0, 6).map((c) => (
              <li key={c.id}><Link to={`/catalogo?cat=${c.id}`} className="hover:text-yellow-300">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-yellow-300 font-bold mb-3 text-sm uppercase tracking-wider">Empresa</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogo" className="hover:text-yellow-300">Catálogo completo</Link></li>
            <li><Link to="/nosotros" className="hover:text-yellow-300">Sobre nosotros</Link></li>
            <li><a href={`https://wa.me/${BIGTIME_WHATSAPP}`} target="_blank" rel="noreferrer" className="hover:text-yellow-300">Atención al cliente</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-yellow-300 font-bold mb-3 text-sm uppercase tracking-wider">Contacto</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="flex items-center gap-2"><Phone size={14} /> 0412-3120579</li>
            <li className="flex items-center gap-2"><Mail size={14} /> hola@bigtimeca.com</li>
            <li className="flex items-center gap-2"><MapPin size={14} /> Venezuela</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 text-xs text-white/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} BIGTIME. Todos los derechos reservados.</span>
          <div className="flex items-center gap-3">
            <Link
              to="/equipo"
              data-testid="footer-team-link"
              className="text-white/40 hover:text-yellow-300 transition"
              title="Portal interno del equipo"
            >
              Portal interno
            </Link>
            <span className="text-white/20">•</span>
            <span>@bigtime_ca • www.bigtimeca.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
